import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';

import { IContentTypeValue } from 'graphql/types';
import { FormSection } from 'common/components/FormSection';
import { ExtraCategoryFormFields } from 'common/forms/Field';
import { TControllerProps } from 'common/types';

export const ExtraCategoriesSection = <TFieldValues extends FieldValues>({
    control,
}: TControllerProps<TFieldValues>) => {
    const [translate] = useTranslation();

    return (
        <FormSection
            renderExpanded
            description={
                <Box>
                    {translate('certificateForm.extraCategoriesDescription')}
                </Box>
            }
            title={translate('certificateForm.extraCategoriesTitle')}
        >
            <ExtraCategoryFormFields
                contentType={IContentTypeValue.Certificate}
                control={control}
                name="extraCategories"
            />
        </FormSection>
    );
};
